import { Typography } from '@design-system/components/typography/typography';
import { Link } from 'react-router';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { LinearProgress } from '@mui/material';
import { bgColorsVars } from '@design-system/vars.css';

type OnboardingProps = {
  checklist: Array<{
    title: string;
    done: boolean;
    to?: string;
    onClick?: () => void;
  }>;
  progres: number;
  completed: number;
};

export const Onboarding = ({
  checklist,
  progres,
  completed,
}: OnboardingProps) => {
  if (checklist.length === 0) return null;
  return (
    <div className="flex flex-col gap-4">
      <Typography variant="body" size="large">
        Kickstart your journey with Playbook by completing these tasks to start
        earning sooner 🤩
      </Typography>
      <div className="flex flex-col md:flex-row gap-4 items-center">
        <Typography
          variant="body"
          size="small"
          fontWeight="normal"
          className="text-[#131313]"
        >
          {completed}/3 completed
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progres}
          sx={{
            width: 325,
            borderRadius: 40,
            '&.MuiLinearProgress-root': {
              background: bgColorsVars['N-40'],
            },
            '&.MuiLinearProgress-root > .MuiLinearProgress-bar1Determinate': {
              background: bgColorsVars['SUCCESS-100'],
            },
          }}
        />
      </div>
      <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
        {checklist.map(({ title, to, done, onClick }) => (
          <div
            key={title}
            className="bg-white p-4 w-[256px] h-[120px] rounded-[10px] flex justify-between"
          >
            <div className="flex flex-col gap-2">
              <Typography variant="body" size="large">
                {title}
              </Typography>
              <Typography
                variant="body"
                size="medium"
                className={clsx(
                  'font-normal',
                  done && sprinkles({ color: 'SUCCESS-100' }),
                  !done && sprinkles({ color: 'ERROR-100' }),
                )}
              >
                {done ? 'Completed' : 'Required to Publish'}
              </Typography>
              {done ? null : !to ? null : (
                <Link to={to} className="cursor-pointer text-black">
                  <Typography className="underline" variant="body" size="large">
                    Continue
                  </Typography>
                </Link>
              )}
              {done ? null : !onClick ? null : (
                <Typography
                  className="underline cursor-pointer"
                  variant="body"
                  size="large"
                  onClick={onClick}
                >
                  Continue
                </Typography>
              )}
            </div>
            {done ? null : (
              <div className="flex items-center">
                <FontAwesomeIcon
                  icon={faCircleExclamation}
                  className={sprinkles({ color: 'ERROR-100', fontSize: 'm' })}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
